export const textCodes = {

    hotline: {
        code: "${merchantId}_tmpl_title_6",
        text: "HOTLINE: 09 440 400 123"
    },

    footerText: {
        code: "${merchantId}_tmpl_title_2",
        text: "ပစ္စည်းမှန် | စျေးတန် | အချိန်မြန်"
    },

    copyText: {
        code: "${merchantId}_tmpl_title_2",
        text: "- All right reserved by Sar Pho Saung - စားဖိုဆောင်"
    },
}

export const titleCodes = {
    footerTitle: {
        code: "${merchantId}_tmpl_title_5",
        title: "Sar Pho Saung - စားဖိုဆောင်"
    },
}